import { Box, Chip } from "@mui/material";
import { colors } from "../../../../ui/colors";

interface Props {
  jobStatus: string;
  status: any;
  jobProgress: number;
}

export const JobCardStatus = ({ jobStatus, status, jobProgress }: Props) => {
  return (
    <Box /*border="1px solid red"*/ display="flex" alignItems="center" gap={1}>
      <Chip
        label={jobStatus.toUpperCase()}
        size="small"
        sx={{
          bgcolor: status.bg,
          color: status.color,
          fontWeight: 600,
          fontSize: 9,
          height: 18,
          minWidth: 80,
        }}
      />

      {jobStatus === "inProgress" && (
        <Chip
          label={`${jobProgress}%`}
          size="small"
          sx={{
            bgcolor: colors.blue[100],
            color: colors.blue[700],
            fontWeight: 600,
            fontSize: 9,
            height: 18,
            minWidth: 44,
          }}
        />
      )}
    </Box>
  );
};
